module.exports = __webpack_public_path__ + "img/member1.7a08242b.jpg";